import React, {useState, useEffect} from 'react'
import {List, ListItem, ListItemAvatar, ListItemText, Avatar, Typography, Paper, ListItemSecondaryAction, Divider} from '@material-ui/core'
import firebase from '../Services/firebase'
import Moment from 'react-moment'
import {animateScroll} from 'react-scroll'
import backGroundImg from '../Assets/back.jpg'
import { makeStyles } from '@material-ui/core/styles';


const useStyles = makeStyles((theme) => ({
    small: {
      width: theme.spacing(4),
      height: theme.spacing(4),
    },
  }))


function Chats(props) {
    const classes = useStyles()
    const [messages, setMessages] = useState([])
    const [userId, setUserId] = useState("")

    useEffect(()=>{

        if(props.roomName){
            var messageRef = firebase.database().ref("/chats/" + props.roomName)
            messageRef.on('value', function(snapshot) {

                var localMessages = []
                snapshot.forEach((doc)=>{
                    localMessages.push(doc.val())
                })
                setMessages(localMessages)
                //console.log(localMessages)
                props.scrollToBottom()
            });
        }

        if(props.userId){
            setUserId(props.userId)
        }
            
    },[props.roomName, props.userId, props.scrollToBottom])

    function randomColor() {
        let hex = Math.floor(Math.random() * 0xFFFFFF)
        let color = "#" + hex.toString(16)
      
        return color
    }

    function hashCode(str) {
        var hash = 0;
        for (var i = 0; i < str.length; i++) {
           hash = str.charCodeAt(i) + ((hash << 5) - hash)
        }
       // console.log(hash);
        return hash
    } 
    
    function intToRGB(i){
        var c = (i & 0x00FFFFFF)
            .toString(16)
            .toUpperCase()

           // console.log(c);
            return "#"+c
    
       // return "00000".substring(0, 6 - c.length) + c;
    }


    return (
        <Paper  style={{ overflow:'auto', height:'63vh'}} id="options-holder">               
            <div>
                <div id="cykablyat" className="cykablyat">
                    <List id="message-list" dense={true}>
                        {messages.map((msg, i)=>(
                           <div key={i} style={{margin: '7px 0px'}}>
                                <ListItem alignItems="flex-start">
                                    <ListItemAvatar style={{margin:'0px -6px'}}>
                                        <Avatar alt={msg.userName} src="/static/images/avatar/1.jpg" className={classes.small} style={{backgroundColor: intToRGB(hashCode(msg.userId))}} />
                                    </ListItemAvatar>
                                    <ListItemText style={{margin:'0px -6px'}}

                                        primary={<Typography style={msg.userId === userId ? {color:'purple'} : {color:'blue'}}>{msg.userName}</Typography>}

                                        secondary={
                                            <Typography>{msg.message}  
                                                <span style={{fontSize:'15px', color:'#777E8B'}}> &nbsp; at { <Moment format="hh:mm MMM DD">{msg.sendingTime}</Moment>}</span>
                                            </Typography>   
                                        }
                                />

                                {/* <Paper>
                                <Typography> <span style={{color:'blue'}}>{msg.userName}</span> <br></br>{msg.message}</Typography>
                                </Paper> */}

                                {/* <ListItemSecondaryAction>
                                    <Typography variant="subtitle2">
                                        <Moment format="hh:mm MMM DD">{msg.sendingTime}</Moment>
                                    </Typography>
                                </ListItemSecondaryAction> */}
                                    
                                
                                </ListItem>  
                             {/* <Divider light/>  */}
                           </div>
                                        
                        ))}
                    </List>  
                </div>
            </div>             
        </Paper>
    )
}

export default Chats
